import { parseLogicActionTarget, type LogicAction } from '../../..'
import * as next from '../../../types/next'
import type { UpLogicHandler } from '../types'

export const up: UpLogicHandler<next.SkipStepLogic> = (
  action: LogicAction
): Omit<
  next.SkipStepLogic,
  'id' | 'orderIndex' | 'triggeredOn' | 'conditions'
> => {
  const targets = parseLogicActionTarget(action.target)

  if (!targets) {
    throw new Error(`Invalid skip step without targets`)
  }

  return {
    action: next.LOGIC_ACTION.SKIP_STEP,
    settings: {
      skipSteps: targets?.split(',')
    }
  }
}
